module.exports = __webpack_public_path__ + "img/wen3.df62ae6e.png";